import { useTranslation } from "react-i18next";

import Cell from "../../components/common/AccordionTable/components/Cell";
import { DividerTableMenu } from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DividerTableMenu";
import DropdownItem from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DropdownItem";
import SpanStyled from "../../components/common/AccordionTable/components/Span";

export const usePortScannerAdapter = () => {
  const { t } = useTranslation();

  const headerData = [
    t("global.port"),
    t("global.status"),
    t("global.description"),
  ];

  const getStatus = status => {
    return status ? t("global.available") : t("global.notAvailable");
  };

  const renderRowContent = item => {
    return (
      <>
        <Cell>{item.port}</Cell>
        <Cell red={!item.status}>{getStatus(item.status)}</Cell>
        <Cell>{item.description}</Cell>
      </>
    );
  };

  const renderHeaderTitle = item => {
    return Object.values(item)[0];
  };

  const renderDropdownContent = item => {
    return (
      <>
        <DropdownItem>
          <span>{headerData[1]}</span>
          <SpanStyled red={!item.status}> {getStatus(item.status)}</SpanStyled>
        </DropdownItem>

        <DividerTableMenu />

        <DropdownItem>
          <span>{headerData[headerData.length - 1]} </span>
          {item.description}
        </DropdownItem>
      </>
    );
  };

  return {
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
    headerData,
  };
};
